import { useEffect, useState } from 'react';
import { getToken } from '../api';

/**
 * A plain <img src="..."> can't carry an Authorization header, and task
 * photos are served through the API (not a public nginx static path) so
 * they can be scan-status-gated. This fetches the photo with the JWT and
 * renders it as a blob URL instead.
 */
export default function AuthedImage({ url, alt, className }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl;
    let cancelled = false;

    async function load() {
      try {
        const response = await fetch(url, {
          headers: { Authorization: `Bearer ${getToken()}` },
        });
        if (!response.ok) throw new Error('photo not available');
        const blob = await response.blob();
        objectUrl = URL.createObjectURL(blob);
        if (!cancelled) setSrc(objectUrl);
      } catch {
        if (!cancelled) setFailed(true);
      }
    }
    load();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  if (failed) return null;
  if (!src) return <div className="photo-placeholder">Loading photo…</div>;
  return <img src={src} alt={alt} className={className} />;
}
